import React from "react";

import { Alert } from "~/components/alert";

import { DocLink } from "../../../../../../../components/react/docLink/DocLink";
import { SILENCING_DOC_LINK_SLUG } from "../../silencing-doc-link-slug";

export function PastRulesAlert() {
	return (
		<Alert variant="warning">
			<strong className="font-semibold">You’re looking at past silencing rules</strong> and, therefore, they cannot be
			removed. To learn more about unmuting monitors,{" "}
			<DocLink capture="noop" slug={SILENCING_DOC_LINK_SLUG}>
				check out our docs
			</DocLink>
			.
		</Alert>
	);
}
